'use strict'
const areaMap = {
	//北海道
	"1": {
		"1": ["101001", "101002", "101003", "101004", "101005", "101006", "101007", "101008", "101009", "101010", "101011", "101012", "10"], //北海道[札幌, ニセコ, トマム, キロロ, ルスツ, 知床, 利尻島, 礼文島, 函館, 富良野, 洞爺湖温泉, 登別温泉] ※全ても含める
	},
	//東北
	"2": {
		"2": ["102001"], //青森[奥入瀬渓流]
		"3": ["102006"], //岩手[安比高原]
		"4": ["102002", "102007"], //宮城[秋保温泉, 鳴子温泉]
		"5": [], //秋田[]
		"6": ["102003", "102004"], //山形[蔵王温泉, 銀山温泉]
		"7": ["102005"], //福島[磐梯]
	},
	//関東
	"3": {
		"8": [], //茨城[]
		"9": ["103006", "103007", "103011"], //栃木[日光, 那須, 鬼怒川温泉]
		"10": ["103004", "103008", "103009", "103010"], //群馬[草津温泉, 四万温泉, 水上温泉, 伊香保温泉]
		"11": [], //埼玉[]
		"12": [], //千葉[]
		"13": ["103001", "103012"], //東京[東京23区, 八丈島]
		"14": ["103002", "103003", "103005"], //神奈川[箱根, 湯河原, 江の島]
	},
	//北陸
	"4": {
		"16": ["104006", "104007"], //富山[宇奈月温泉, 立山]
		"17": ["104001", "104002", "104003", "104004"], //石川[金沢, 和倉温泉, 加賀温泉郷, 粟津温泉]
		"18": ["104005"], //福井[あわら温泉]
	},
	//甲信越
	"5": {
		"15": ["105009", "105010"], //新潟[湯沢温泉, 佐渡島]
		"19": ["105008"], //山梨[河口湖]
		"20": ["105001", "105002", "105003", "105004", "105005", "105006", "105007"], //長野[軽井沢, 白馬, 上高地, 渋・湯田中温泉, 蓼科, 白骨温泉, 野沢温泉]
	},
	//東海
	"6": {
		"21": ["106002", "106003", "106004"], //岐阜[飛騨高山, 下呂温泉, 奥飛騨温泉]
		"22": ["106001", "106005", "106008", "106009"], //静岡[熱海, 初島, 東伊豆, 西伊豆]
		"23": [], //愛知[]
		"24": ["106006", "106007"], //三重[鳥羽, 伊勢志摩]
	},
	//関西
	"7": {
		"25": ["107003"], //滋賀[雄琴温泉・琵琶湖]
		"26": ["107001"], //京都[京都市周辺]
		"27": [], //大阪[]
		"28": ["107002", "107004", "107005", "107007"], //兵庫[城崎温泉, 有馬温泉, 淡路島, ハチ高原]
		"29": [], //奈良[]
		"30": ["107006"], //和歌山[白浜海岸]
	},
	//中国
	"8": {
		"31": ["108002", "108003", "108004"], //鳥取[皆生温泉, 大山, 三朝温泉]
		"32": ["108005"], //島根[玉造温泉]
		"33": [], //岡山[]
		"34": ["108001", "108006"], //広島[宮島, めがひら]
		"35": [], //山口[]
	},
	//四国
	"9": {
		"36": ["109002"], //徳島[鳴門温泉]
		"37": ["109001"], //香川[小豆島・直島]
		"38": [], //愛媛[]
		"39": [], //高知[]
	},
	//九州
	"10" : {
		"40": [], //福岡[]
		"41": [], //佐賀[]
		"42": ["110001"], //長崎[ハウステンボス]
		"43": ["110005"], //熊本[黒川温泉]
		"44": ["110004"], //大分[湯布院]
		"45": [], //宮崎[]
		"46": ["110002", "110003"], //鹿児島[屋久島, 奄美大島]
	},
	//沖縄
	"11" : {
		"47": ["111001", "111002", "111003", "111004", "111005", "111006", "111007", "111008", "10"], //沖縄[沖縄本島, 那覇市, 恩納村, 久米島, 石垣島, 西表島, 小浜島, 宮古島] ※全ても含める
	}
}

export default areaMap
